import DeliveryStopsList from '../../../../components/Purchasing/Packages/Stops/DeliveryStopsList'
import DeliveryStopsModal from '../../../../components/Purchasing/Packages/Stops/DeliveryStopsModal'

import React, { Fragment } from 'react'

function DeliveryStops (props) {
  return (
    <Fragment>
      <DeliveryStopsModal {...props} />
      <DeliveryStopsList {...props} />
    </Fragment>
  )
}

export default DeliveryStops
